import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  getFactoryByGroupID,
  GetSuppliersByItemIDAndFactoryID,
  GetQuotationsBySupplier,
  SaveQuotationDetails,
  GetRequisitionNumbers,
  GetItemsByRequisitionFactoryID,
  GetItemsQuantityByItem,
  GetAllQuotationDetails,
  GetSuppliersByItem,
  uploadSelectedRequisitions,
  getRequisitionDetails,
  getAllGroups,
  GetWarehousesByGroupIDAndFactoryID,
  getBudgetCodeDetails,
  getStatusDetails
};

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    const data = response?.data ?? [];
        const dataArray = Array.isArray(data) ? data : Object.values(data);
    const factoryObject = dataArray.reduce((acc, item) => {
        acc[item.factoryID] = item.factoryName;
        return acc;
    }, {});
    
    return factoryObject;
}

async function GetSuppliersByItemIDAndFactoryID(GardenID, factoryID) {
  var supplierArray = [];
  const response = await CommonGet('/api/QuotationComplete/GetSuppliersByGroup', "groupID=" + parseInt(GardenID) + "&factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    supplierArray[item[1]["supplierID"]] = item[1]["supplierName"];
  }
  return supplierArray;
}

async function GetQuotationsBySupplier(groupID, factoryID, supplierID) {
  const response = await CommonGet('/api/QuotationComplete/GetQuotationsBySupplier', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&supplierID=" + parseInt(supplierID));
  return response.data;
}

async function SaveQuotationDetails(saveModel) {
  const response = await CommonPost('/api/QuotationDetails/SaveQuotationDetails', null, saveModel);
  return response;
}

async function GetAllQuotationDetails(groupID, factoryID, supplierID, quotationHeaderID) {
  let model = {
    groupID: parseInt(groupID),
    factoryID: parseInt(factoryID),
    SupplierID: parseInt(supplierID),
    QuotationHeaderID: parseInt(quotationHeaderID)
  }
  const response = await CommonPost('/api/QuotationComplete/GetQuotation', null, model);
  return response;
}

async function GetRequisitionNumbers(factoryID) {
  const response = await CommonGet('/api/Quotation/GetRequisitionNumbers', 'factoryID=' + parseInt(factoryID))
  let data = response.data;
  return data;
}

async function GetSuppliersByItem(itemID) {
  const response = await CommonGet('/api/Quotation/GetSuppliersByItem', 'skuMasterID=' + parseInt(itemID))
  let data = response.data;
  return data;
}

async function GetItemsByRequisitionFactoryID(array) {
  let string = array.join(',');
  const response = await CommonGet('/api/Quotation/GetItemsByRequisitions', 'reuisitionNumbers=' + (string))
  let itemArray = [];
  for (let item of Object.entries(response.data)) {
    itemArray[item[1]["skuMasterID"]] = item[1]["skuMasterName"];
  }
  return itemArray;
}

async function GetItemsQuantityByItem(array, itemID) {
  let string = array.join(',');
  const response = await CommonGet('/api/Quotation/GetItemsQuantityByItem', 'reuisitionNumbers=' + (string) + "&ItemID=" + parseInt(itemID))
  return response.data;
}

async function uploadSelectedRequisitions(model) {
  const response = await CommonPost('/api/QuotationComplete/CompleteQuotation', null, model);
  return response;
}

async function getAllGroups() {
    let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function GetWarehousesByGroupIDAndFactoryID(groupID, estateID) {
    const response = await CommonGet('/api/Requisition/GetWarehouseID', 'groupID=' + groupID + '&estateID=' + estateID)
    let wareHouses = []
    for (let item of Object.entries(response.data)) {
        wareHouses[item[1]["warehouseID"]] = item[1]["warehouseName"]
    }
    return wareHouses;
}

async function getBudgetCodeDetails() {
    let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes',null);
    let budgetCodeArray = [];
    for (let item of Object.entries(response.data)) {
      budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
    }
    //budgetCodeArray.unshift('--Select Account Code--')
    return budgetCodeArray;
  };

  async function getStatusDetails() {
    let response = await CommonGet('/api/QuotationComplete/getQuotationCompleteStatusDetails',null);
    let statusArray = [];
    for (let item of Object.entries(response.data)) {
        statusArray[item[1]["statusID"]] = item[1]["statusName"];
    }
    return statusArray;
  };


async function getRequisitionDetails(model) {
    const response = await CommonGet(
        '/api/QuotationComplete/getRequisitionCompleteListningDetails',
        'groupID=' + model.groupID +
        '&factoryID=' + model.factoryID +
        '&supplierID=' + model.supplierID +
        '&requisitionStatus=' + model.requisitionStatus
    );
    return response;
}



